<meta-title i18n>יצירת חשבון</meta-title>

<div class="auth-page">
  <header class="auth-page-header">
    <h2 i18n>יצירת חשבון</h2>
    <p i18n>השלימו את הפרטים כדי להמשיך בהרשמה</p>
  </header>

  <div class="auth-card">
    <div class="auth-identity-chip" *ngIf="identityKey">
      <div class="auth-identity-chip__meta">
        <mat-icon aria-hidden="true">badge</mat-icon>
        <span class="muted" i18n
          >{identityMethod, select, idNumber {תעודת זהות} passport
          {דרכון}}:</span
        >
        <span class="value" dir="ltr">{{ identityKey }}</span>
      </div>
      <button type="button" (click)="reset()">
        <span i18n>שינוי</span>
        <mat-icon>arrow_back</mat-icon>
      </button>
    </div>

    <form
      [formGroup]="form"
      autocomplete="off"
      novalidate
      (submit)="register()"
    >
      <div class="auth-field">
        <label for="auth-email" i18n>כתובת אימייל</label>
        <div class="auth-input-wrap">
          <mat-icon class="auth-input-icon" aria-hidden="true">mail</mat-icon>
          <input
            id="auth-email"
            class="auth-input"
            [autofocus]="loadState"
            type="email"
            formControlName="email"
            autocomplete="email"
            required
            placeholder="לצורך קבלת קוד אימות"
            i18n-placeholder
          />
        </div>

        <p class="auth-hint" i18n>אנא הזן את כתובת הדוא"ל שלך</p>

        <div class="auth-field__feedback" aria-live="polite">
          <p class="auth-field-error" *ngIf="form | hasError: 'email'" i18n>
            אנחנו צריכים כתובת דוא"ל תקינה שלך
          </p>
        </div>
      </div>

      <div class="auth-form-actions">
        <ui-progress-button
          class="auth-submit"
          color="primary"
          [disabled]="form.invalid"
          [state]="registerState"
          i18n
        >
          {registerState.value, select, inProcess {יוצר חשבון...} other
          {יצירת חשבון וכניסה}}
        </ui-progress-button>

        <button type="button" class="auth-secondary-btn" (click)="reset()" i18n>
          ביטול
        </button>
      </div>

      <div
        class="auth-alert"
        *visible="registerState.error?.isInvalidModel"
        i18n
      >
        כתובת הדוא"ל שהזנת אינה תקינה
      </div>

      <ui-error [state]="registerState" [ignoreList]="[400]"> </ui-error>
    </form>
  </div>
</div>
